<template>
  <div class="feedbackgivers">
    <section class="table-section">
      <b-table :data="feedbackGivers" paginated pagination-simple per-page="10">
        <b-table-column
          field="first_name"
          label="First Name"
          v-slot="props"
          sortable
          :searchable="isSearchable"
        >
          {{ props.row.first_name }}
        </b-table-column>

        <b-table-column
          field="last_name"
          label="Last Name"
          v-slot="props"
          sortable
          :searchable="isSearchable"
        >
          {{ props.row.last_name }}
        </b-table-column>

        <b-table-column
          field="email"
          label="Email"
          v-slot="props"
          sortable
          :searchable="isSearchable"
        >
          {{ props.row.email }}
        </b-table-column>
        <b-table-column
          class="progressfield"
          field="progress"
          label="Given"
          width="100"
          v-slot="props"
          sortable
        >
          <ColourCodedProgressBar :number="props.row.progress" />
        </b-table-column>

        <b-table-column label="Actions" v-slot="props">
          <inertia-link
            :href="
              route('users.show', {
                user: props.row.unique_id,
                project: project.unique_id,
              })
            "
          >
            <b-button type="is-primary" size="is-small">View</b-button>
          </inertia-link>
          <b-button
            type="is-danger"
            size="is-small"
            @click="unlinkFeedbackGiver(props.row)"
          >
            <b-icon pack="fas" icon="user-times" size="is-small"></b-icon>
          </b-button>
        </b-table-column>
      </b-table>
    </section>

    <!-- unlink user modal -->
    <b-modal
      v-model="unlinkModal"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p>
            <b
              >Are you sure that you want to unlink
              {{ unlinkFeedbackGiverName }}?</b
            >
          </p>
        </header>
        <section class="modal-card-body">
          <b-loading
            :is-full-page="false"
            :active="unlinkIsLoading"
            :can-cancel="false"
          ></b-loading>
          <span v-if="!unlinkIsLoading">
            <b-message v-if="willBeDeleted" type="is-danger">
              <p><b>This user will be deleted</b></p>
              <p class="small">
                This user is not linked to any other projects, and is not a
                participant, and so will be deleted from the system.
              </p>
            </b-message>
            <p v-else>This user will be unlinked</p>
            <p class="mt-5 mb-3">
              Please type <b>{{ unlinkFeedbackGiverName }}</b> below to confirm
            </p>
            <b-input
              v-model="unlinkConfirmation"
              placeholder="Type name here"
            ></b-input>
            <form @submit.prevent="unlinkSubmit">
              <b-button
                native-type="submit"
                v-if="unlinkFeedbackGiverName == unlinkConfirmation"
                type="is-danger"
                class="mt-3"
                >Unlink</b-button
              >
            </form>
          </span>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ColourCodedProgressBar from '../../Components/Management/ColourCodedProgressBar.vue';

export default {
  props: {
    feedbackGivers: { type: Array },
    project: Object,
  },

  components: {
    ColourCodedProgressBar,
  },

  data() {
    return {
      unlinkModal: false,
      unlinkFeedbackGiverName: '',
      unlinkConfirmation: '',
      unlinkIsLoading: true,
      feedbackGiver: null,
    };
  },
  methods: {
    unlinkFeedbackGiver(feedbackGiver) {
      this.unlinkModal = true;
      this.unlinkConfirmation = '';
      this.unlinkFeedbackGiverName =
        feedbackGiver.first_name + ' ' + feedbackGiver.last_name;
      this.feedbackGiver = feedbackGiver;

      fetch(
        route('users.getFeedbackGiverUnlinkConfirmationMessage', {
          project: this.project.unique_id,
          user: feedbackGiver.unique_id,
        })
      )
        .then((response) => response.json())
        .then((data) => {
          this.willBeDeleted = data.willBeDeleted;
          this.unlinkIsLoading = false;
        });
    },
    unlinkSubmit() {
      this.$inertia.post(
        route('users.unlinkFeedbackGiver', {
          project: this.project.unique_id,
          user: this.feedbackGiver.unique_id,
        }),
        {},
        {
          onSuccess: () => {
            this.unlinkModal = false;
            this.$buefy.toast.open({
              message: 'User unlinked',
              type: 'is-success',
              position: 'is-top',
            });
            this.$emit('refresh');
          },
          onError: () => {
            this.$buefy.toast.open({
              message: 'Something went wrong while unlinking the user',
              type: 'is-danger',
              position: 'is-top',
            });
          },
        }
      );
    },
  },
  computed: {
    isSearchable: function () {
      return this.feedbackGivers.length > 10;
    },
  },
};
</script>
